/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
export var AnalyzeDocumentRequest = {
  type: {
    name: "Composite",
    className: "AnalyzeDocumentRequest",
    modelProperties: {
      urlSource: {
        serializedName: "urlSource",
        type: {
          name: "String"
        }
      },
      base64Source: {
        serializedName: "base64Source",
        type: {
          name: "ByteArray"
        }
      }
    }
  }
};
export var ErrorResponse = {
  type: {
    name: "Composite",
    className: "ErrorResponse",
    modelProperties: {
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "ErrorModel"
        }
      }
    }
  }
};
export var ErrorModel = {
  type: {
    name: "Composite",
    className: "ErrorModel",
    modelProperties: {
      code: {
        serializedName: "code",
        required: true,
        type: {
          name: "String"
        }
      },
      message: {
        serializedName: "message",
        required: true,
        type: {
          name: "String"
        }
      },
      target: {
        serializedName: "target",
        type: {
          name: "String"
        }
      },
      details: {
        serializedName: "details",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ErrorModel"
            }
          }
        }
      },
      innererror: {
        serializedName: "innererror",
        type: {
          name: "Composite",
          className: "InnerError"
        }
      }
    }
  }
};
export var InnerError = {
  type: {
    name: "Composite",
    className: "InnerError",
    modelProperties: {
      code: {
        serializedName: "code",
        required: true,
        type: {
          name: "String"
        }
      },
      message: {
        serializedName: "message",
        type: {
          name: "String"
        }
      },
      innererror: {
        serializedName: "innererror",
        type: {
          name: "Composite",
          className: "InnerError"
        }
      }
    }
  }
};
export var AnalyzeResultOperation = {
  type: {
    name: "Composite",
    className: "AnalyzeResultOperation",
    modelProperties: {
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["notStarted", "running", "failed", "succeeded"]
        }
      },
      createdDateTime: {
        serializedName: "createdDateTime",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      lastUpdatedDateTime: {
        serializedName: "lastUpdatedDateTime",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "ErrorModel"
        }
      },
      analyzeResult: {
        serializedName: "analyzeResult",
        type: {
          name: "Composite",
          className: "AnalyzeResult"
        }
      }
    }
  }
};
export var AnalyzeResult = {
  type: {
    name: "Composite",
    className: "AnalyzeResult",
    modelProperties: {
      apiVersion: {
        serializedName: "apiVersion",
        required: true,
        type: {
          name: "String"
        }
      },
      modelId: {
        constraints: {
          Pattern: new RegExp("[a-zA-Z0-9][a-zA-Z0-9._~-]{1,63}")
        },
        serializedName: "modelId",
        required: true,
        type: {
          name: "String"
        }
      },
      stringIndexType: {
        serializedName: "stringIndexType",
        required: true,
        type: {
          name: "String"
        }
      },
      content: {
        serializedName: "content",
        required: true,
        type: {
          name: "String"
        }
      },
      pages: {
        serializedName: "pages",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentPage"
            }
          }
        }
      },
      paragraphs: {
        serializedName: "paragraphs",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentParagraph"
            }
          }
        }
      },
      tables: {
        serializedName: "tables",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentTable"
            }
          }
        }
      },
      keyValuePairs: {
        serializedName: "keyValuePairs",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentKeyValuePair"
            }
          }
        }
      },
      styles: {
        serializedName: "styles",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentStyle"
            }
          }
        }
      },
      languages: {
        serializedName: "languages",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentLanguage"
            }
          }
        }
      },
      documents: {
        serializedName: "documents",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Document"
            }
          }
        }
      }
    }
  }
};
export var DocumentPage = {
  type: {
    name: "Composite",
    className: "DocumentPage",
    modelProperties: {
      kind: {
        serializedName: "kind",
        required: true,
        type: {
          name: "String"
        }
      },
      pageNumber: {
        constraints: {
          InclusiveMinimum: 1
        },
        serializedName: "pageNumber",
        required: true,
        type: {
          name: "Number"
        }
      },
      angle: {
        constraints: {
          InclusiveMaximum: 180,
          ExclusiveMinimum: -180
        },
        serializedName: "angle",
        type: {
          name: "Number"
        }
      },
      width: {
        constraints: {
          InclusiveMinimum: 0
        },
        serializedName: "width",
        type: {
          name: "Number"
        }
      },
      height: {
        constraints: {
          InclusiveMinimum: 0
        },
        serializedName: "height",
        type: {
          name: "Number"
        }
      },
      unit: {
        serializedName: "unit",
        type: {
          name: "String"
        }
      },
      spans: {
        serializedName: "spans",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSpan"
            }
          }
        }
      },
      words: {
        serializedName: "words",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentWord"
            }
          }
        }
      },
      selectionMarks: {
        serializedName: "selectionMarks",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSelectionMark"
            }
          }
        }
      },
      images: {
        serializedName: "images",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentImage"
            }
          }
        }
      },
      lines: {
        serializedName: "lines",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentLine"
            }
          }
        }
      }
    }
  }
};
export var DocumentSpan = {
  type: {
    name: "Composite",
    className: "DocumentSpan",
    modelProperties: {
      offset: {
        constraints: {
          InclusiveMinimum: 0
        },
        serializedName: "offset",
        required: true,
        type: {
          name: "Number"
        }
      },
      length: {
        constraints: {
          InclusiveMinimum: 0
        },
        serializedName: "length",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var DocumentWord = {
  type: {
    name: "Composite",
    className: "DocumentWord",
    modelProperties: {
      content: {
        serializedName: "content",
        required: true,
        type: {
          name: "String"
        }
      },
      polygon: {
        serializedName: "polygon",
        type: {
          name: "Sequence",
          element: {
            constraints: {
              InclusiveMinimum: 0
            },
            type: {
              name: "Number"
            }
          }
        }
      },
      span: {
        serializedName: "span",
        type: {
          name: "Composite",
          className: "DocumentSpan"
        }
      },
      confidence: {
        constraints: {
          InclusiveMaximum: 1,
          InclusiveMinimum: 0
        },
        serializedName: "confidence",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var DocumentSelectionMark = {
  type: {
    name: "Composite",
    className: "DocumentSelectionMark",
    modelProperties: {
      state: {
        serializedName: "state",
        required: true,
        type: {
          name: "String"
        }
      },
      polygon: {
        serializedName: "polygon",
        type: {
          name: "Sequence",
          element: {
            constraints: {
              InclusiveMinimum: 0
            },
            type: {
              name: "Number"
            }
          }
        }
      },
      span: {
        serializedName: "span",
        type: {
          name: "Composite",
          className: "DocumentSpan"
        }
      },
      confidence: {
        constraints: {
          InclusiveMaximum: 1,
          InclusiveMinimum: 0
        },
        serializedName: "confidence",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var DocumentImage = {
  type: {
    name: "Composite",
    className: "DocumentImage",
    modelProperties: {
      polygon: {
        serializedName: "polygon",
        type: {
          name: "Sequence",
          element: {
            constraints: {
              InclusiveMinimum: 0
            },
            type: {
              name: "Number"
            }
          }
        }
      },
      span: {
        serializedName: "span",
        type: {
          name: "Composite",
          className: "DocumentSpan"
        }
      },
      pageRef: {
        constraints: {
          InclusiveMinimum: 0
        },
        serializedName: "pageRef",
        required: true,
        type: {
          name: "Number"
        }
      },
      confidence: {
        constraints: {
          InclusiveMaximum: 1,
          InclusiveMinimum: 0
        },
        serializedName: "confidence",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var DocumentLine = {
  type: {
    name: "Composite",
    className: "DocumentLine",
    modelProperties: {
      content: {
        serializedName: "content",
        required: true,
        type: {
          name: "String"
        }
      },
      polygon: {
        serializedName: "polygon",
        type: {
          name: "Sequence",
          element: {
            constraints: {
              InclusiveMinimum: 0
            },
            type: {
              name: "Number"
            }
          }
        }
      },
      spans: {
        serializedName: "spans",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSpan"
            }
          }
        }
      }
    }
  }
};
export var DocumentParagraph = {
  type: {
    name: "Composite",
    className: "DocumentParagraph",
    modelProperties: {
      role: {
        serializedName: "role",
        type: {
          name: "String"
        }
      },
      content: {
        serializedName: "content",
        required: true,
        type: {
          name: "String"
        }
      },
      boundingRegions: {
        serializedName: "boundingRegions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BoundingRegion"
            }
          }
        }
      },
      spans: {
        serializedName: "spans",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSpan"
            }
          }
        }
      }
    }
  }
};
export var BoundingRegion = {
  type: {
    name: "Composite",
    className: "BoundingRegion",
    modelProperties: {
      pageNumber: {
        constraints: {
          InclusiveMinimum: 1
        },
        serializedName: "pageNumber",
        required: true,
        type: {
          name: "Number"
        }
      },
      polygon: {
        serializedName: "polygon",
        required: true,
        type: {
          name: "Sequence",
          element: {
            constraints: {
              InclusiveMinimum: 0
            },
            type: {
              name: "Number"
            }
          }
        }
      }
    }
  }
};
export var DocumentTable = {
  type: {
    name: "Composite",
    className: "DocumentTable",
    modelProperties: {
      rowCount: {
        constraints: {
          InclusiveMinimum: 1
        },
        serializedName: "rowCount",
        required: true,
        type: {
          name: "Number"
        }
      },
      columnCount: {
        constraints: {
          InclusiveMinimum: 1
        },
        serializedName: "columnCount",
        required: true,
        type: {
          name: "Number"
        }
      },
      cells: {
        serializedName: "cells",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentTableCell"
            }
          }
        }
      },
      caption: {
        serializedName: "caption",
        type: {
          name: "Composite",
          className: "DocumentCaption"
        }
      },
      footnotes: {
        serializedName: "footnotes",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentFootnote"
            }
          }
        }
      },
      boundingRegions: {
        serializedName: "boundingRegions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BoundingRegion"
            }
          }
        }
      },
      spans: {
        serializedName: "spans",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSpan"
            }
          }
        }
      }
    }
  }
};
export var DocumentTableCell = {
  type: {
    name: "Composite",
    className: "DocumentTableCell",
    modelProperties: {
      kind: {
        defaultValue: "content",
        serializedName: "kind",
        type: {
          name: "String"
        }
      },
      rowIndex: {
        serializedName: "rowIndex",
        required: true,
        type: {
          name: "Number"
        }
      },
      columnIndex: {
        serializedName: "columnIndex",
        required: true,
        type: {
          name: "Number"
        }
      },
      rowSpan: {
        defaultValue: 1,
        constraints: {
          InclusiveMinimum: 1
        },
        serializedName: "rowSpan",
        type: {
          name: "Number"
        }
      },
      columnSpan: {
        defaultValue: 1,
        constraints: {
          InclusiveMinimum: 1
        },
        serializedName: "columnSpan",
        type: {
          name: "Number"
        }
      },
      content: {
        serializedName: "content",
        required: true,
        type: {
          name: "String"
        }
      },
      boundingRegions: {
        serializedName: "boundingRegions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BoundingRegion"
            }
          }
        }
      },
      spans: {
        serializedName: "spans",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSpan"
            }
          }
        }
      }
    }
  }
};
export var DocumentCaption = {
  type: {
    name: "Composite",
    className: "DocumentCaption",
    modelProperties: {
      content: {
        serializedName: "content",
        required: true,
        type: {
          name: "String"
        }
      },
      boundingRegions: {
        serializedName: "boundingRegions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BoundingRegion"
            }
          }
        }
      },
      spans: {
        serializedName: "spans",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSpan"
            }
          }
        }
      }
    }
  }
};
export var DocumentFootnote = {
  type: {
    name: "Composite",
    className: "DocumentFootnote",
    modelProperties: {
      content: {
        serializedName: "content",
        required: true,
        type: {
          name: "String"
        }
      },
      boundingRegions: {
        serializedName: "boundingRegions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BoundingRegion"
            }
          }
        }
      },
      spans: {
        serializedName: "spans",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSpan"
            }
          }
        }
      }
    }
  }
};
export var DocumentKeyValuePair = {
  type: {
    name: "Composite",
    className: "DocumentKeyValuePair",
    modelProperties: {
      key: {
        serializedName: "key",
        type: {
          name: "Composite",
          className: "DocumentKeyValueElement"
        }
      },
      value: {
        serializedName: "value",
        type: {
          name: "Composite",
          className: "DocumentKeyValueElement"
        }
      },
      confidence: {
        constraints: {
          InclusiveMaximum: 1,
          InclusiveMinimum: 0
        },
        serializedName: "confidence",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var DocumentKeyValueElement = {
  type: {
    name: "Composite",
    className: "DocumentKeyValueElement",
    modelProperties: {
      content: {
        serializedName: "content",
        required: true,
        type: {
          name: "String"
        }
      },
      boundingRegions: {
        serializedName: "boundingRegions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BoundingRegion"
            }
          }
        }
      },
      spans: {
        serializedName: "spans",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSpan"
            }
          }
        }
      }
    }
  }
};
export var DocumentStyle = {
  type: {
    name: "Composite",
    className: "DocumentStyle",
    modelProperties: {
      isHandwritten: {
        serializedName: "isHandwritten",
        type: {
          name: "Boolean"
        }
      },
      spans: {
        serializedName: "spans",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSpan"
            }
          }
        }
      },
      confidence: {
        constraints: {
          InclusiveMaximum: 1,
          InclusiveMinimum: 0
        },
        serializedName: "confidence",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var DocumentLanguage = {
  type: {
    name: "Composite",
    className: "DocumentLanguage",
    modelProperties: {
      locale: {
        serializedName: "locale",
        required: true,
        type: {
          name: "String"
        }
      },
      spans: {
        serializedName: "spans",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSpan"
            }
          }
        }
      },
      confidence: {
        constraints: {
          InclusiveMaximum: 1,
          InclusiveMinimum: 0
        },
        serializedName: "confidence",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var Document = {
  type: {
    name: "Composite",
    className: "Document",
    modelProperties: {
      docType: {
        constraints: {
          MaxLength: 64,
          MinLength: 2
        },
        serializedName: "docType",
        required: true,
        type: {
          name: "String"
        }
      },
      boundingRegions: {
        serializedName: "boundingRegions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BoundingRegion"
            }
          }
        }
      },
      spans: {
        serializedName: "spans",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSpan"
            }
          }
        }
      },
      fields: {
        serializedName: "fields",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Composite",
              className: "DocumentField"
            }
          }
        }
      },
      confidence: {
        constraints: {
          InclusiveMaximum: 1,
          InclusiveMinimum: 0
        },
        serializedName: "confidence",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var DocumentField = {
  type: {
    name: "Composite",
    className: "DocumentField",
    modelProperties: {
      type: {
        serializedName: "type",
        required: true,
        type: {
          name: "String"
        }
      },
      valueString: {
        serializedName: "valueString",
        type: {
          name: "String"
        }
      },
      valueDate: {
        serializedName: "valueDate",
        type: {
          name: "Date"
        }
      },
      valueTime: {
        serializedName: "valueTime",
        type: {
          name: "String"
        }
      },
      valuePhoneNumber: {
        serializedName: "valuePhoneNumber",
        type: {
          name: "String"
        }
      },
      valueNumber: {
        serializedName: "valueNumber",
        type: {
          name: "Number"
        }
      },
      valueInteger: {
        serializedName: "valueInteger",
        type: {
          name: "Number"
        }
      },
      valueSelectionMark: {
        serializedName: "valueSelectionMark",
        type: {
          name: "String"
        }
      },
      valueSignature: {
        serializedName: "valueSignature",
        type: {
          name: "String"
        }
      },
      valueCountryRegion: {
        serializedName: "valueCountryRegion",
        type: {
          name: "String"
        }
      },
      valueArray: {
        serializedName: "valueArray",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentField"
            }
          }
        }
      },
      valueObject: {
        serializedName: "valueObject",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Composite",
              className: "DocumentField"
            }
          }
        }
      },
      valueCurrency: {
        serializedName: "valueCurrency",
        type: {
          name: "Composite",
          className: "CurrencyValue"
        }
      },
      valueAddress: {
        serializedName: "valueAddress",
        type: {
          name: "Composite",
          className: "AddressValue"
        }
      },
      content: {
        serializedName: "content",
        type: {
          name: "String"
        }
      },
      boundingRegions: {
        serializedName: "boundingRegions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BoundingRegion"
            }
          }
        }
      },
      spans: {
        serializedName: "spans",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSpan"
            }
          }
        }
      },
      confidence: {
        constraints: {
          InclusiveMaximum: 1,
          InclusiveMinimum: 0
        },
        serializedName: "confidence",
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var CurrencyValue = {
  type: {
    name: "Composite",
    className: "CurrencyValue",
    modelProperties: {
      amount: {
        serializedName: "amount",
        required: true,
        type: {
          name: "Number"
        }
      },
      currencySymbol: {
        serializedName: "currencySymbol",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var AddressValue = {
  type: {
    name: "Composite",
    className: "AddressValue",
    modelProperties: {
      houseNumber: {
        serializedName: "houseNumber",
        type: {
          name: "String"
        }
      },
      poBox: {
        serializedName: "poBox",
        type: {
          name: "String"
        }
      },
      road: {
        serializedName: "road",
        type: {
          name: "String"
        }
      },
      city: {
        serializedName: "city",
        type: {
          name: "String"
        }
      },
      state: {
        serializedName: "state",
        type: {
          name: "String"
        }
      },
      postalCode: {
        serializedName: "postalCode",
        type: {
          name: "String"
        }
      },
      countryRegion: {
        serializedName: "countryRegion",
        type: {
          name: "String"
        }
      },
      streetAddress: {
        serializedName: "streetAddress",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var BuildDocumentModelRequest = {
  type: {
    name: "Composite",
    className: "BuildDocumentModelRequest",
    modelProperties: {
      modelId: {
        constraints: {
          Pattern: new RegExp("[a-zA-Z0-9][a-zA-Z0-9._~-]{1,63}")
        },
        serializedName: "modelId",
        required: true,
        type: {
          name: "String"
        }
      },
      description: {
        constraints: {
          MaxLength: 4096
        },
        serializedName: "description",
        type: {
          name: "String"
        }
      },
      buildMode: {
        serializedName: "buildMode",
        required: true,
        type: {
          name: "String"
        }
      },
      azureBlobSource: {
        serializedName: "azureBlobSource",
        type: {
          name: "Composite",
          className: "AzureBlobContentSource"
        }
      },
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
export var AzureBlobContentSource = {
  type: {
    name: "Composite",
    className: "AzureBlobContentSource",
    modelProperties: {
      containerUrl: {
        serializedName: "containerUrl",
        required: true,
        type: {
          name: "String"
        }
      },
      prefix: {
        serializedName: "prefix",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var ComposeDocumentModelRequest = {
  type: {
    name: "Composite",
    className: "ComposeDocumentModelRequest",
    modelProperties: {
      modelId: {
        constraints: {
          Pattern: new RegExp("[a-zA-Z0-9][a-zA-Z0-9._~-]{1,63}")
        },
        serializedName: "modelId",
        required: true,
        type: {
          name: "String"
        }
      },
      description: {
        constraints: {
          MaxLength: 4096
        },
        serializedName: "description",
        type: {
          name: "String"
        }
      },
      componentModels: {
        constraints: {
          UniqueItems: true
        },
        serializedName: "componentModels",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ComponentModelInfo"
            }
          }
        }
      },
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
export var ComponentModelInfo = {
  type: {
    name: "Composite",
    className: "ComponentModelInfo",
    modelProperties: {
      modelId: {
        constraints: {
          Pattern: new RegExp("[a-zA-Z0-9][a-zA-Z0-9._~-]{1,63}")
        },
        serializedName: "modelId",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
export var AuthorizeCopyRequest = {
  type: {
    name: "Composite",
    className: "AuthorizeCopyRequest",
    modelProperties: {
      modelId: {
        constraints: {
          Pattern: new RegExp("[a-zA-Z0-9][a-zA-Z0-9._~-]{1,63}")
        },
        serializedName: "modelId",
        required: true,
        type: {
          name: "String"
        }
      },
      description: {
        constraints: {
          MaxLength: 4096
        },
        serializedName: "description",
        type: {
          name: "String"
        }
      },
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
export var CopyAuthorization = {
  type: {
    name: "Composite",
    className: "CopyAuthorization",
    modelProperties: {
      targetResourceId: {
        serializedName: "targetResourceId",
        required: true,
        type: {
          name: "String"
        }
      },
      targetResourceRegion: {
        serializedName: "targetResourceRegion",
        required: true,
        type: {
          name: "String"
        }
      },
      targetModelId: {
        constraints: {
          Pattern: new RegExp("[a-zA-Z0-9][a-zA-Z0-9._~-]{1,63}")
        },
        serializedName: "targetModelId",
        required: true,
        type: {
          name: "String"
        }
      },
      targetModelLocation: {
        serializedName: "targetModelLocation",
        required: true,
        type: {
          name: "String"
        }
      },
      accessToken: {
        serializedName: "accessToken",
        required: true,
        type: {
          name: "String"
        }
      },
      expirationDateTime: {
        serializedName: "expirationDateTime",
        required: true,
        type: {
          name: "DateTime"
        }
      }
    }
  }
};
export var GetOperationsResponse = {
  type: {
    name: "Composite",
    className: "GetOperationsResponse",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "OperationInfo"
            }
          }
        }
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var OperationInfo = {
  type: {
    name: "Composite",
    className: "OperationInfo",
    modelProperties: {
      operationId: {
        serializedName: "operationId",
        required: true,
        type: {
          name: "String"
        }
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["notStarted", "running", "failed", "succeeded", "canceled"]
        }
      },
      percentCompleted: {
        constraints: {
          InclusiveMaximum: 100,
          InclusiveMinimum: 0
        },
        serializedName: "percentCompleted",
        type: {
          name: "Number"
        }
      },
      createdDateTime: {
        serializedName: "createdDateTime",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      lastUpdatedDateTime: {
        serializedName: "lastUpdatedDateTime",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      kind: {
        serializedName: "kind",
        required: true,
        type: {
          name: "String"
        }
      },
      resourceLocation: {
        serializedName: "resourceLocation",
        required: true,
        type: {
          name: "String"
        }
      },
      apiVersion: {
        serializedName: "apiVersion",
        type: {
          name: "String"
        }
      },
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
export var GetModelsResponse = {
  type: {
    name: "Composite",
    className: "GetModelsResponse",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ModelSummary"
            }
          }
        }
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var ModelSummary = {
  type: {
    name: "Composite",
    className: "ModelSummary",
    modelProperties: {
      modelId: {
        constraints: {
          Pattern: new RegExp("[a-zA-Z0-9][a-zA-Z0-9._~-]{1,63}")
        },
        serializedName: "modelId",
        required: true,
        type: {
          name: "String"
        }
      },
      description: {
        constraints: {
          MaxLength: 4096
        },
        serializedName: "description",
        type: {
          name: "String"
        }
      },
      createdDateTime: {
        serializedName: "createdDateTime",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      apiVersion: {
        serializedName: "apiVersion",
        type: {
          name: "String"
        }
      },
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
export var DocTypeInfo = {
  type: {
    name: "Composite",
    className: "DocTypeInfo",
    modelProperties: {
      description: {
        constraints: {
          MaxLength: 4096
        },
        serializedName: "description",
        type: {
          name: "String"
        }
      },
      buildMode: {
        serializedName: "buildMode",
        type: {
          name: "String"
        }
      },
      fieldSchema: {
        serializedName: "fieldSchema",
        required: true,
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Composite",
              className: "DocumentFieldSchema"
            }
          }
        }
      },
      fieldConfidence: {
        serializedName: "fieldConfidence",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Number"
            },
            constraints: {
              InclusiveMaximum: 1,
              InclusiveMinimum: 0
            }
          }
        }
      }
    }
  }
};
export var DocumentFieldSchema = {
  type: {
    name: "Composite",
    className: "DocumentFieldSchema",
    modelProperties: {
      type: {
        serializedName: "type",
        required: true,
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "description",
        type: {
          name: "String"
        }
      },
      example: {
        serializedName: "example",
        type: {
          name: "String"
        }
      },
      items: {
        serializedName: "items",
        type: {
          name: "Composite",
          className: "DocumentFieldSchema"
        }
      },
      properties: {
        serializedName: "properties",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Composite",
              className: "DocumentFieldSchema"
            }
          }
        }
      }
    }
  }
};
export var GetInfoResponse = {
  type: {
    name: "Composite",
    className: "GetInfoResponse",
    modelProperties: {
      customDocumentModels: {
        serializedName: "customDocumentModels",
        type: {
          name: "Composite",
          className: "CustomDocumentModelsInfo"
        }
      }
    }
  }
};
export var CustomDocumentModelsInfo = {
  type: {
    name: "Composite",
    className: "CustomDocumentModelsInfo",
    modelProperties: {
      count: {
        serializedName: "count",
        required: true,
        type: {
          name: "Number"
        }
      },
      limit: {
        serializedName: "limit",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var GetOperationResponse = {
  type: {
    name: "Composite",
    className: "GetOperationResponse",
    modelProperties: Object.assign(Object.assign({}, OperationInfo.type.modelProperties), {
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "ErrorModel"
        }
      },
      result: {
        serializedName: "result",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "any"
            }
          }
        }
      }
    })
  }
};
export var ModelInfo = {
  type: {
    name: "Composite",
    className: "ModelInfo",
    modelProperties: Object.assign(Object.assign({}, ModelSummary.type.modelProperties), {
      docTypes: {
        serializedName: "docTypes",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Composite",
              className: "DocTypeInfo"
            }
          }
        }
      }
    })
  }
};
export var GeneratedClientAnalyzeDocumentHeaders = {
  type: {
    name: "Composite",
    className: "GeneratedClientAnalyzeDocumentHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var GeneratedClientBuildDocumentModelHeaders = {
  type: {
    name: "Composite",
    className: "GeneratedClientBuildDocumentModelHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var GeneratedClientComposeDocumentModelHeaders = {
  type: {
    name: "Composite",
    className: "GeneratedClientComposeDocumentModelHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var GeneratedClientCopyDocumentModelToHeaders = {
  type: {
    name: "Composite",
    className: "GeneratedClientCopyDocumentModelToHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String"
        }
      }
    }
  }
};